import styled from 'styled-components'

export const Pipeline = styled.div`
  display: flex;
  height: 100vh;
  gap: 1.4rem;
`

export const StepColumn = styled.div`
  height: fit-content;
  width: 300px;
  border-radius: .8rem;
  overflow: hidden;
`

export const StepHeader = styled.div`
  padding: 1rem;
  font-size: 1rem;
  font-weight: 700;
  color: #3a3a3a;
  line-height: 1.4;
  background-color: #fff;
`

export const TitleWithActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-left: auto;
`

export const IconButton = styled.button`
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.15rem;
  cursor: pointer;
  color: #6b7280;
  transition: color 0.15s ease;

  &:hover {
    color: #0090d3;
  }
`

export const TicketList = styled.ul`
  background-color: #EBEBEB;
  padding: .7rem;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  gap: .7rem;
`

export const TicketItem = styled.li`
  background-color: #fff;
  user-select: none;
  padding: 1rem;
  border-radius: .8rem;
  display: flex;
  flex-direction: column;
  gap: .5rem;
`

export const CardTitle = styled.h3`
  font-size: 0.95rem;
  font-weight: 600;
  color: #1f1f1f;
  line-height: 1.4;
`

export const HorizontalDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  width: 100%;
`

export const MetaData = styled.label<{color?: string, fontSize?: string}>`
  font-size: ${({fontSize}) => fontSize || '0.75rem'};
  font-weight: 500;
  color: ${({color}) => color || '#6b7280'};
  display: flex;
  align-items: center;
  gap: .25rem;
`

export const AddInStep = styled.button`
  padding: .3rem;
  border-radius: .8rem;
  color: #0090d3;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 700;
  border: none;
  width: 100%;
  margin-top: .7rem;
  background-color: transparent;
`

export const InputForAdd = styled.input`
  width: calc(100% - 1.5rem);
  border: none;
  outline: none;
  background-color: #F4F4F4;
  height: 40px;
  padding: 0 1rem;
  border-radius: .5rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #696969;
`

export const AddStep = styled.button`
  border-radius: 50%;
  background-color: #fff;
  width: 3rem;
  height: 3rem;
  border: 1.5px solid #0090D3;
  color: #0090D3;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
`